import { Epic } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';

import { loadStatusesRequest, loadStatusesSuccess, loadStatusesFail } from './statuses.actions';
import { IStatuses } from './statuses.types';

export const statusesEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadStatusesRequest),
    mergeMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/statuses`).pipe(
        map((payload: IStatuses) => loadStatusesSuccess(payload)),
        catchError(errorHandler({ callbacks: loadStatusesFail })),
      ),
    ),
  );

export const statusesEpics = [statusesEpic];
